var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("application-list-loader")
    : _c(
        "div",
        {
          staticClass: "container-fluid mb-5 px-md-5",
          attrs: { id: "applications-list-container" },
        },
        [
          _c(
            "div",
            { staticClass: "row justify-content-center" },
            [
              _c("page-header", {
                attrs: { title: _vm.getTitle(), size: "col-auto" },
                scopedSlots: _vm._u([
                  {
                    key: "inlinebuttons",
                    fn: function () {
                      return [
                        _c(
                          "applications-list-actions",
                          _vm._b(
                            {
                              ref: "applicationActions",
                              attrs: {
                                "current-agent": _vm.currentAgent,
                                "logged-in-agent": _vm.userDetails.username,
                                "show-agents": _vm.isBrokerAccount,
                                "is-property-account": _vm.isPropertyAccount,
                              },
                              on: {
                                "search-client": _vm.searchClient,
                                change: _vm.filterAgent,
                                import: _vm.showImportModal,
                                add: _vm.showAddClientModal,
                                filter: _vm.handleFilter,
                              },
                            },
                            "applications-list-actions",
                            _vm.clientsTableFilters,
                            false
                          )
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("import-clients-modal", { ref: "importModal" }),
          _vm._v(" "),
          _c(
            "add-client-modal",
            _vm._b(
              {
                ref: "addClientModal",
                attrs: { id: "add-client-from-applications" },
                on: { hidden: _vm.resetData },
              },
              "add-client-modal",
              _vm.modalData,
              false
            )
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clients-table-wrapper row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "d-flex mb-2" }, [
                _c(
                  "h6",
                  {
                    staticClass:
                      "grey-text text-darken-1 text-primary bold mb-0 text-nowrap",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.tableSummaryText) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.currentFilters
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-row flex-wrap align-items-start",
                      },
                      _vm._l(_vm.currentFilters, function (tag) {
                        return _c(
                          "span",
                          {
                            key: tag.text,
                            staticClass:
                              "ml-2 badge status-badge current-filter-badge",
                            style:
                              "--progress-item-variation: " +
                              tag.variation +
                              "deg",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(tag.text) +
                                "\n            "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "ml-1 clickable",
                                on: {
                                  click: function ($event) {
                                    return _vm.clearFilter(tag.filter)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-times",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "position-relative" },
                [
                  _c("copy-application-modal", {
                    attrs: {
                      "application-street": _vm.applicationStreet,
                      "current-address-length": _vm.currentAddressObjLength,
                      "document-count": _vm.documentCount,
                    },
                    on: { "copy-application": _vm.onCopyApp },
                  }),
                  _vm._v(" "),
                  _c("applications-list-table", {
                    ref: "applicationsTable",
                    attrs: {
                      id: "clients-table",
                      clients: _vm.currentClients,
                      "all-action-buttons": _vm.isPropertyAccount,
                      "table-name": "clients",
                      loading: _vm.loadingTable,
                      "copying-app": _vm.copyingApp,
                    },
                    on: {
                      "new-app": _vm.onCreateApp,
                      sort: _vm.handleSort,
                      "open-modal": _vm.openModal,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.loadingClients
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [_c("load-more-loader")],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }